import { Card, CardHeader } from 'components/common';
import {
  PopupDesc,
  PopupIconWrapper,
  PopupTitle,
} from 'components/Popup/ConfirmDialog/ConfirmDialog.styled';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { WaitingListFormValues } from 'hooks/patient/waitingList/useWaitingList';
import { useFormContext } from 'react-hook-form';
import { FaClock, FaQuestion } from 'react-icons/fa';
import { CardLoader } from '../../../components/common/Loading';
import { WaitingListHelpButton } from './WaitingList.styled';
import { WaitingListButtonBar } from './WaitingListButtonBar';
import { WaitingListFor } from './WaitingListFor';
import { useWaitingListFormData } from './WaitingListFormHooks';
import { WaitingListRows } from './WaitingListRows';

export const WaitingListForm = () => {
  const { t } = useCommonTranslation();
  const form = useFormContext<WaitingListFormValues>();

  const {
    isLoading,
    helpURL,
    onSubmit,
    deleteWaitingList,
    ...waitingListRowsData
  } = useWaitingListFormData();

  return (
    <Card>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <CardHeader>
          <WaitingListFor />
          <PopupIconWrapper inlineIcon>
            <FaClock />
          </PopupIconWrapper>
          <PopupTitle>{t('waiting-list')}</PopupTitle>
          <PopupDesc>{t('waiting-list-description')}</PopupDesc>

          <WaitingListHelpButton
            variant="primary"
            type="button"
            iconOnly
            size="auto"
            to={helpURL}
            aria-label={t('waiting-list-help-title')}
          >
            <FaQuestion />
          </WaitingListHelpButton>
        </CardHeader>
        {isLoading ? (
          <CardLoader />
        ) : (
          <>
            <WaitingListRows {...waitingListRowsData} />
          </>
        )}
        <WaitingListButtonBar
          isLoading={isLoading}
          deleteWaitingList={deleteWaitingList}
        />
      </form>
    </Card>
  );
};
